var map = {
	"./bg1.jpg": 77,
	"./bg2.jpg": 78,
	"./bg3.jpg": 79,
	"./bg4.jpg": 80,
	"./bg5.jpg": 81,
	"./bg6.jpg": 82,
	"./bg7.jpg": 83,
	"./bg8.jpg": 84,
	"./bg9.jpg": 85
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76;